

  <div class="sidebar">
  
    <div class="profile-details" [matMenuTriggerFor]="profileDropdown">
        <div class="profile-content" *ngIf="pictureUrl && loggedInUserDetails != null" title="{{loggedInUserDetails?.firstName}}&nbsp;{{loggedInUserDetails?.lastName}}">
          <img [src]="pictureUrl" alt="profileImg">
        </div>
        <div class="profile-content"  *ngIf="!pictureUrl && loggedInUserDetails != undefined && loggedInUserDetails != null " title="{{loggedInUserDetails?.firstName}}&nbsp;{{loggedInUserDetails?.lastName}}">
           <span [ngStyle]="{'background-color':loggedInUserDetails?.userSettingDTO.staffTheme, 'color':loggedInUserDetails?.userSettingDTO.staffTheme == '#ffffff' ? '#0091fb':'#ffffff'}">
               {{getShortName(loggedInUserDetails?.firstName)}}{{getShortName(loggedInUserDetails?.lastName)}}
           </span>
        </div>
      </div>
      <mat-menu #profileDropdown="matMenu" xPosition="after" >
        <button mat-menu-item class="d-flex justify-content-evenly"  (click)="openProfile()"  > 
            <span style="width: 30%;">
                <i class="fa fa-user" aria-hidden="true" ></i>
            </span>
            <span style="width: 70%;">
                {{'View profile'|translate}}
            </span>
        </button>
     
        <button mat-menu-item class="d-flex justify-content-between" *ngIf="loggedInUserDetails?.darkMode" (click)="changeTheme(false)"> 
            <span style="width: 30%;">
                <i   class="fa fa-sun"></i>
            </span>
            <span style="width: 70%;">
                {{'Light Theme'|translate}}
            </span>
        </button>
        <button mat-menu-item class="d-flex justify-content-between" (click)="changeTheme(true)" *ngIf="!loggedInUserDetails?.darkMode"> 
            <span style="width: 30%;">
                <i   class="fa fa-moon"></i>
            </span>
            <span style="width: 70%;">
                {{'Dark Theme'|translate}}
            </span>
        </button>
        <button mat-menu-item class="d-flex justify-content-between" (click)="logout()"> 
            <span style="width: 30%;">
                <i class="fa fa-power-off"></i>
            </span>
            <span style="width: 70%;">
                {{'Log Out'|translate}}
            </span>
        </button>
    
      </mat-menu>
   
    <ul class="nav-links">
      <li  *ngFor="let item of menu" [ngClass]='{active:activeMenu==item}' (click)='changeMenuItem(item)' [hidden]='!item.show'>
        <div class="iocn-link">
          <a href="javascript:void(0)">
            <i  [ngClass]="item.icon" aria-hidden="true" *ngIf="item.icon" ></i>
            <span class="link_name">{{item.title  | translate }}</span>
          </a>
        </div>
       
        <ul class="sub-menu"  >
          <li style="box-shadow: none;"><a class="link_name" href="javascript:void(0)" (click)='changeMenuItem(item)'>{{item.title  | translate }}</a></li>
          <li style="border-radius: 8px; box-shadow: none;"  *ngFor="let subMenu of item.children"    [hidden]='!subMenu.show'>
              <ng-container *ngIf="item.title == 'Schedule' || item.title == 'Dashboard' || item.title == 'Settings' ">
                <a [ngClass]="{'disable-anchor': subMenu?.disabled == true }" (click)="changeMenuItemwithSub(item,subMenu);stopPropagation($event)" href="javascript:void(0)">{{subMenu.title | translate}}</a>

            </ng-container>
            <ng-container *ngIf="!(item.title == 'Schedule' || item.title == 'Dashboard' || item.title == 'Settings') && activeMenu==item">
                <a [ngClass]="{'disable-anchor': subMenu?.disabled == true }" (click)="navigate(subMenu);stopPropagation($event)" href="javascript:void(0)">{{subMenu.title | translate}}</a>

            </ng-container>
        </li>
        </ul>
      </li>
 
      <li>
 
  </li>
</ul>
  </div>

